import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "gatsby-plugin-intl";

const Common_mdr_table = ({children}) => {
    return (
        <table className="table-auto">
            <thead>
            <tr>
                <th className="p-2" />
                <th className="p-2"><FormattedMessage id="softpos.plan.mdr_rate" defaultMessage="交易費用" /></th>
                <th className="p-2"><FormattedMessage id="softpos.plan.bankin_date" defaultMessage="到賬所需時間" /></th>
            </tr>
            </thead>    
            <tbody>{children}</tbody>
        </table>
    );
}

Common_mdr_table.propTypes = {
    children: PropTypes.string
};

export default Common_mdr_table;